import { ApplicationRef, Component, NgZone, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {TranslocoService} from '@ngneat/transloco';
import { filter, take, delay, switchMap, tap, catchError } from 'rxjs/operators';
import { CapacitorUpdater } from '@capgo/capacitor-updater'

import { usersnapInit } from '@app/services';
import { Platform } from '@ionic/angular';
import { SwUpdate } from '@angular/service-worker';
import { EMPTY, interval } from 'rxjs';

import { SplashScreen } from '@capacitor/splash-screen'
import { App, URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core';

import { ApiService } from './services/api/api.service';

import  packageJson  from '../../../../package.json'
import { theme } from '@theme/.';


declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  updating = false;
  downloadProgress = 0;
  public version: string = packageJson.version;
  theme = theme
  appConfigs = {
    banner_message:{
      show: false
    }
  }
  lang = localStorage.getItem('lang')

  constructor(
    private translate: TranslocoService,
    public router: Router,
    private appRef: ApplicationRef,
    private zone: NgZone,
    private swUpdate: SwUpdate,
    public platform: Platform,
    private apiService: ApiService,
  ) {

    fetch("https://d3pqqdxgpmvwhw.cloudfront.net/configs/patientlynk_config.json", {
      method: 'GET',
      headers: {
          'Accept': 'application/json',
      },
    }).then(response => response.json()).then(response => this.appConfigs = response)

    this.initializeApp();

    switch (theme.name) {
      case 'MisResultados': {
        this.measurementID = 'G-E75HJKQ7NM';
        this.GAv4 = true;
      }
      break;
      default: {
        this.GAv4 = false;
      }
      // as more GA widgets are developed for more environments, they will be specified here.
      //  For the moment, MisRes environment is using the current GA.
    }

    if (this.GAv4 === true) {   // new GA code if version is 4
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          gtag('config', this.measurementID, { 'page_path': event.urlAfterRedirects });
        }
      })
    }
  }

  initializeApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
            // Example url: https://beerswift.app/tabs/tab2
            // slug = /tabs/tab2
            const slug = event.url.split(".com").pop();
            if (slug) {
                this.router.navigateByUrl(slug);
            }
            // If no match, do nothing - let regular routing
            // logic take over
        });
    });
  }

  public measurementID:string = '';   //  measurement ID for google analytics v4
  public GAv4:boolean = false;        //  will represent if google analitics is v4 or previous

  async setNewVersion(response, compare_result){
    let version: any;
    // Do the download during user active app time to prevent failed download
    version = await CapacitorUpdater.download({
      url: response.update_url,
    })

    console.log("version", version);

    if (version !== "" && (compare_result == 1)) {
      // Do the switch when user leave app
      SplashScreen.show()
      try {
        await CapacitorUpdater.set(version)
      } catch (error) {
        console.log("error");

        SplashScreen.hide() // in case the set fail, otherwise the new app will have to hide it
      }
    }
  }

  ngOnInit() {

    SplashScreen.hide();

    if (Capacitor.isNativePlatform()) {
      this.apiService.getWebPackage(theme?.lis?.toLowerCase(), this.version).subscribe((response: any) => {
        let { bundle_version } = response
        console.log("getWebPackage", response);
        //compare_result returns and integer; 0 is a = b; 1 is a > b; -1 is a < b;
        let compare_result = bundle_version.localeCompare(this.version, undefined, { numeric: true, sensitivity: 'base' })
        console.log("packageJson result", bundle_version, this.version, compare_result);

        let version: any;

        this.setNewVersion(response, compare_result)

        // App.addListener('appStateChange', async(state) => {
        //   if (state.isActive) {
        //     // Do the download during user active app time to prevent failed download
        //     version = await CapacitorUpdater.download({
        //       url: response.update_url,
        //     })
        //   }

        //   console.log("version", version);

        //   if (!state.isActive && version !== "" && (compare_result == 1)) {
        //     // Do the switch when user leave app
        //     SplashScreen.show()
        //     try {
        //       await CapacitorUpdater.set(version)
        //     } catch (error) {
        //       console.log("error");

        //       SplashScreen.hide() // in case the set fail, otherwise the new app will have to hide it
        //     }
        //   }
        // })

    // })
      })
    }

    this.setLanguage();

    // Don't load Usersnap, Fullstory until loading is complete
    this.appRef.isStable.pipe(
      take(1),
      delay(1000),
      // don't load analytics during development
      // filter(() => !window.location.href.includes('localhost')),
      tap(() => this.handleWorker()),
    ).subscribe(() => this.initExternal());
  }

  setLanguage() {
    const [ browserLang ] = navigator?.language?.split('-');
    const availableLangs = this.translate.getAvailableLangs() as string[];
    this.translate.setDefaultLang(
      localStorage.getItem('lang') ||
      availableLangs.find(lang => lang === browserLang) || 'en'
    );
  }

  registerGAPageviews() {
    if (this.GAv4 === false) {  // if ga version is not 4, do the default code block

      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        (window as any).ga('set', 'page', event.urlAfterRedirects);
        (window as any).ga('send', 'pageview');
      });

    }
  }

  // FreshDesk widget config
  loadFreshDesk(id): void   {
        window["fwSettings"] = {
          widget_id: id,
          locale: localStorage.getItem('lang'), // active language
        };

        (function () {
          if ('function' !== typeof window["FreshworksWidget"]) {
            const n = function () {
              n.q.push(arguments);
            };
            (n.q = []), (window["FreshworksWidget"] = n);
          }
        })();
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://widget.freshworks.com/widgets/' + id + '.js';
        document.getElementsByTagName('head')[0].appendChild(script);
  }

  initExternal() {
    this.zone.runOutsideAngular(() => {
      usersnapInit();
      // check which Freshdesk variant to load
      if (theme.name == 'LabInfo')  {
        this.loadFreshDesk('151000001193');
        // console.log('Labinfo / 151000001193')
      } else if (theme.name == 'MisResultados')   {
        // console.log('MisRes / 150000002711')
        this.loadFreshDesk('150000002711');
      }

      // prevents Google Analytic from loading in dev (see commit desc)
      (async () => {
        const fullStory: any = await import('@fullstory/browser').catch();
        fullStory?.init?.({ orgId: 'VJGY2' });
      })();


      // Google Analytics
      if (this.GAv4 === false) {  // verify if environment is GA version 4, otherwise run code from previous version

          (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function() {
              (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * (new Date() as any);
            a = s.createElement(o),
              m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
          })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
          window['ga']('create', 'UA-123679004-2', 'auto');
      }

    });

    this.registerGAPageviews();
  }

  // Use SwUpdate API to force an application reload when an unrecoverable
  // cache state is encountered.
  handleWorker() {
    this.swUpdate.unrecoverable.pipe(
      switchMap(() => this.swUpdate.checkForUpdate()),
      switchMap(() => this.swUpdate.versionUpdates),
      switchMap(() => this.swUpdate.activateUpdate()),
      switchMap(() => this.swUpdate.activateUpdate()),
      catchError(() => EMPTY),
    ).subscribe(_ => window.location.reload());
  }
}
